const environment = "production"
// const environment = "local"
//For local setup
const local = {
    apiUrl: "http://localhost:8000",
    // PORT: ''
};

//For staging server
const staging = {
    // apiUrl: "http://54.201.160.69:9210",
    apiUrl: "https://staging.helpr.bm:8001",
    // PORT: ''
};




const production = {
    apiUrl: "https://api.helpr.bm",
    // PORT: ''
};

// console.log("process.env.REACT_APP_ENV :", process.env.REACT_APP_ENV);

if (environment === "local") module.exports = local;
else if (environment === "staging") module.exports = staging;
else if (environment === "production") module.exports = production;
else module.exports = local;